import { render, staticRenderFns } from "./edit_modal.vue?vue&type=template&id=def60478&scoped=true&"
import script from "./edit_modal.vue?vue&type=script&lang=js&"
export * from "./edit_modal.vue?vue&type=script&lang=js&"
import style0 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./edit_modal.vue?vue&type=style&index=1&id=def60478&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "def60478",
  null
  
)

export default component.exports